import axios, { AxiosResponse } from 'axios';
import { startOfDay } from 'date-fns';

import { ORGANIZATIONAL_UNIT_CHILDREN } from 'RestAPIs/endpoints';

import { LinkMode } from './LinkPlanUnitForm';

export const getOrganizationalUnits = async (
  brId: number,
  linkMode: LinkMode
) => {
  const referenceDate = startOfDay(new Date(2023, 9, 28)).toISOString();
  return await axios
    .get<string[], AxiosResponse<string[]>>(ORGANIZATIONAL_UNIT_CHILDREN, {
      params: {
        organizationalUnitId: brId,
        referenceDate: referenceDate,
        includeAllChildren: linkMode === 'PLAN_UNIT_AND_ALL_OF_ITS_CHILDREN'
      }
    })
    .then(({ data }) => data);
};
export const getOrganizationalUnitsWithoutAllChildren = async (
  brId: number,
  oldReferenceDate?: Date
) => {
  const referenceDate = startOfDay(new Date()).toISOString();
  return await axios
    .get<string[], AxiosResponse<string[]>>(ORGANIZATIONAL_UNIT_CHILDREN, {
      params: {
        organizationalUnitId: brId,
        referenceDate: oldReferenceDate ?? referenceDate,
        includeAllChildren: false
      }
    })
    .then(({ data }) => {
      // eslint-disable-next-line no-console
      console.log('sadfg: ', data);
      return data;
    });
};
